import {useCallback,useEffect,useState} from 'react';
import {useAuth} from '../../contexts/AuthContext';
import {attachScenarios} from '../practice/practiceSections';
import {numberQuestions} from '../practice/voiceCommands';
import {canAccessTracker} from './trackerModel';
import {cachedTrackerCatalog,clearTrackerCatalog,loadTrackerCatalog,selectTrackerAccount} from './trackerCatalogClient';

const empty={paper:null,questions:[],loading:true,error:'',slow:false};
const prepare=value=>({paper:value.paper,questions:numberQuestions(attachScenarios(value.questions.map(q=>({...q,createdAt:{toMillis:()=>q.createdAtMs || 0}})),{allowUnavailable:true}))});
export default function useTrackerCatalog(paperId) {
    const {user,userData}=useAuth(),uid=user?.uid,allowed=canAccessTracker(userData,paperId),key=`${uid}:${paperId}:${allowed}`;
    const [state,setState]=useState(empty),[revision,setRevision]=useState(0);
    useEffect(()=>{
        selectTrackerAccount(uid);let active=true;
        if(!uid || !allowed){clearTrackerCatalog(uid,paperId);setState({...empty,key,loading:false,error:'This tracker is not available to your account.'});return;}
        const cached=cachedTrackerCatalog(uid,paperId);
        if(cached){setState({...prepare(cached),key,loading:false,error:'',slow:false});return;}
        setState({...empty,key});
        const timer=setTimeout(()=>{if(active)setState(previous=>({...previous,slow:true}));},8000);
        loadTrackerCatalog(uid,paperId).then(value=>{
            if(active)setState({...prepare(value),key,loading:false,error:'',slow:false});
        }).catch(error=>{
            if(active)setState({...empty,key,loading:false,error:error.code==='functions/permission-denied'?'Your tracker access could not be confirmed. Return to the dashboard or contact your coordinator.':'The question list could not load. Check your connection and try again.'});
        }).finally(()=>clearTimeout(timer));
        return()=>{active=false;clearTimeout(timer);};
    },[uid,paperId,allowed,key,revision]);
    const reload=useCallback(()=>{clearTrackerCatalog(uid,paperId);setRevision(value=>value+1);},[uid,paperId]);
    return {...(state.key===key?state:empty),reload};
}
